module.exports = __webpack_public_path__ + "img/1.5f7de167.jpg";